// @flow
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import styles from './SecondaryMenu.styles';

class SecondaryMenu extends React.Component<Props> {
    render() {
        const { classes } = this.props;
        return (
          <Hidden xsDown>
            <div className={classes.root}>
              <Link to={`/`}>صفحه اصلی</Link>
            </div>
          </Hidden>
        );
    }
}

const mapStateToProps = state => ({
  menuList: state.menu,
  navigation: state.navigation
});

const styledComponent = withStyles(styles, {withTheme: true})(SecondaryMenu);
const Component = connect(mapStateToProps)(styledComponent);
export {Component as SecondaryMenu};
export default Component;